import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-form-filling-modal',
  templateUrl: './form-filling-modal.component.html',
  styleUrls: ['./form-filling-modal.component.scss']
})
export class FormFillingModalComponent implements OnInit {

  list: any[] = [];
  percentRange: string = '';
  itemCount: number = 0;
  docType: string = '';
  dateRegister: string = '';

  constructor(
    private dialogRef: MatDialogRef<FormFillingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.list = this.data;
    this.docType = this.list[0].docType;
    this.itemCount = this.list.length;
    this.list.forEach(element => {
      element.filledFields = this.calculateFilledFields(element);
      if (element.docType === 'CPF') {
        element.label = element.name;
        element.labelTruncated = element.name.length > 14 ? element.name.substring(0, 14) + '...' : element.name;
      } else if (element.docType === 'CNPJ') {
        element.label = element.name;
        element.labelTruncated = element.name.length > 14 ? element.name.substring(0, 14) + '...' : element.name;
      } else if (element.docType === 'chassi') {
        element.label = element.vehicleModel;
        element.labelTruncated = element.vehicleModel.length > 14 ? element.vehicleModel.substring(0, 14) + '...' : element.vehicleModel;
      } else if (element.docType === 'código do corretor') {
        element.label = element.brokerName;
        element.labelTruncated = element.brokerName.length > 14 ? element.brokerName.substring(0, 14) + '...' : element.brokerName;
      }
      if (element.filledFields < 25) {
        element.percentRange = 'teste-xpto-25';
      } else if (element.filledFields >= 25 && element.filledFields < 50) {
        element.percentRange = 'teste-xpto-50';
      } else {
        element.percentRange = 'teste-xpto-100';
      }
    });
  }

  calculateFilledFields(obj: any): number {
    const _obj = obj;
    let totalItems = Object.keys(obj).length;
    let filledItems = 0;
    Object.keys(obj).forEach(element => {
      if (_obj[element] != null && _obj[element] != "") {
        filledItems++;
      }
    });
    return Math.round((filledItems / totalItems) * 100);
  };

  close() {
    this.dialogRef.close();
  };

  getItemAndCloseModal(item: any) {
    this.dialogRef.close(item);
  }
}
